<template>
  <v-app class="container">
    <br />
    <v-card>
      <v-card-title v-if="gindicadores === null" class="grey lighten-4 change-font" primary-title>
        <div class="spinner-grow"></div>Cargando indicadores &#8230;
      </v-card-title>
      <v-card-title v-else class="grey lighten-4 change-font" primary-title>Indicadores</v-card-title>
      <v-card-text>
        <br />
        <v-row>
          <v-col>

            <v-select v-model="tiposclasificador" :items="gtiposclasificador" item-text="nombre" label="Instrumento"
              :no-data-text="gnodata" return-object multiple @change="filtrar" clearable
              hint="Seleccione el instrumento de Planeación - PMI, Planes Nacionales y PND." persistent-hint></v-select>

          </v-col>
          <v-col>
            <v-select label="Sector:" item-text="nombre" :no-data-text="gnodata"
              :items="gsectores.filter(e => e.activo == true)" return-object v-model="sector" @change="filtrar"
              clearable></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select label="Entidad:" item-text="nombre" :items="entidades.filter(e => e.activo == true)"
              :no-data-text="gnodata" return-object v-model="entidad" @change="filtrar" clearable></v-select>
          </v-col>
          <v-col>
            <v-select clearable label="Clasificación:" :items="gclasificaciones" :no-data-text="gnodata"
              item-text="nombre" return-object v-model="clasificacion" @change="filtrar">
              <template slot="selection" slot-scope="data">
                <div>{{ data.item.codigo }} {{ data.item.nombre }}</div>
              </template>
            </v-select>

          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="codigo" label="Código" clearable @click:clear="limpiarcodigo"
              @keyup="filtrar"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field v-model="nombre" label="Nombre" clearable @click:clear="limpiarnombre"
              @keyup="filtrar"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select clearable :searchable="false" :filterable="false" label="Punto:" item-text="nombre"
              item-value="idpunto" value="idpunto" :no-data-text="gnodata" :items="gpuntos" return-object v-model="punto"
              @change="filtrar"></v-select>
          </v-col>
          <v-col>
            <v-select clearable :searchable="false" :filterable="false" label="Pilar:" :no-data-text="gnodata"
              item-text="nombrecompleto" :items="pilares" return-object v-model="pilar" @change="filtrar"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select clearable :searchable="false" :filterable="false" label="Estrategia:" item-text="nombrecompleto"
              :items="estrategias" :no-data-text="gnodata" return-object v-model="estrategia"
              @change="filtrar"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select clearable :searchable="false" :filterable="false" label="Línea:" item-text="nombrecompleto"
              :no-data-text="gnodata" :items="lineas" return-object v-model="linea" @change="filtrar"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-select clearable :searchable="false" :filterable="false" label="Producto:" item-text="nombrecompleto"
              item-value="idproducto" :no-data-text="gnodata" :items="productos" return-object v-model="producto"
              @change="filtrar"></v-select>
          </v-col>
        </v-row>

        <v-data-table v-if="gindicadores !== null" :headers="headerFields" :items="datos" class="elevation-2"
          :no-data-text="gnodata" dense :items-per-page="10">
          <template v-slot:item.action="{ item }">
            <div v-if="item.finalizado === true">
              <div style="display: flex;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon small class="mr-2" v-on="on" @click="editItem(item)">mdi-eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon small class="mr-2" v-on="on" @click="desagregacionItem(item)">mdi-file-excel</v-icon>
                  </template>
                  <span>Desagregación</span>
                </v-tooltip>
              </div>
            </div>
            <div v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small color="red" class="mr-2" v-on="on">mdi-eye</v-icon>
                </template>
                <span>Sin ficha técnica</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:footer>
            <div id="div1" v-show="showdownload" style="width:100%;align:right">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <download-excel id="div2" style="width:100%;text-align: right;" v-show="datos.length > 0"
                    class="btn btn-default" :data="datos" :exportFields="exportable" name="indicadores.xls" type="xls"
                    worksheet="Información">
                    <v-icon color="secondary" v-on="on" large elevation="2">mdi-file-download-outline</v-icon>
                  </download-excel>
                </template>
                <span>Descargar</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snack" :timeout="5000" :color="MesaggeInfo.color">
      {{ this.MesaggeInfo.codigoRespuesta }}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="snack = false">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";

export default {
  name: "publicicador",
  components: {},
  data: function () {
    return {
      exportable: {
        ID: "idindicador",
        Punto: "idpunto",
        Código: "codigo",
        Indicador: "nombre",
        "Entidad responsable de reporte": "entidades.nombre",
        Inicio: "inicio",
        Fin: "fin",
        Estado: "idestadoNavigation.nombre",
        "Fecha de creación": "fechacreacion",
        "Usuario de modificación": "nombreUsuarioModificacion"
      },

      headerFields: [
        { text: "Código", value: "codigo", fixed: true, width: "100px" },
        { value: "nombre", text: "Nombre" },
        { value: "entidades.nombre", text: "Responsable", width: "30%" },
        { text: "Acción", value: "action", sortable: false }
      ],
      datos: [],
      codigo: "",
      nombre: "",
      tiposclasificador: [],
      punto: undefined,
      pilar: undefined,
      pilares: [],
      estrategia: undefined,
      estrategias: [],
      linea: undefined,
      lineas: [],
      producto: undefined,
      productos: [],
      entidades: [],
      sectores: [],
      clasificacion: undefined,
      entidad: undefined,
      sector: undefined,
      sectorbloqueado: false,
      entidadbloqueada: false,
      filtro: undefined,
      snack: false,
      snackColor: "",
      snackText: "",
      showdownload: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],

    };
  },
  created() {

    if (this.gopciones !== undefined) {
      this.cargarpuntos();
    } else {
      this.cargaropciones();
    }
    this.cargarsectores();
    this.cargarentidades();
    this.get_productos();
    this.get_lineas();
    this.get_estrategias();
    this.get_pilares();
    this.get_clasificaciones();
    this.get_tiposclasificador();
    this.get_indicadores();
  },
  mounted() {
    let vfiltro = localStorage.filtroindicadorP;
    if (vfiltro !== undefined) {
      this.filtro = JSON.parse(unescape(vfiltro));
      this.nombre = this.filtro.nombre;
      this.codigo = this.filtro.codigo;
    }
  },
  computed: {
    ...mapGetters([
      "gindicadores",
      "gpuntos",
      "gpilares",
      "gestrategias",
      "glineas",
      "gproductos",
      "gclasificaciones",
      "gsectores",
      "gentidades",
      "gopciones",
      "gtiposclasificador"
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    itemsporpagina() {
      if (!isNaN(this.itemsPerPageSopCuan)) return this.itemsPerPageSopCuan;
      else return 1;
    }
  },
  methods: {
    ...mapActions([
      "get_indicadores",
      "get_puntos",
      "get_pilares",
      "get_estrategias",
      "get_lineas",
      "get_productos",
      "get_clasificaciones",
      "get_entidadesbysector",
      "get_sectores",
      "Getentidad",
      "get_puntosbyusuario",
      "get_tiposclasificador",
      "get_porusuario"
    ]),
    cargarpuntos() {
      let opciones = this.gopciones.filter(p => p.codigo === "O004-1-2");
      if (opciones.length === 0) {
        this.get_puntos();
      } else {
        this.get_puntosbyusuario({
          params: { idusuario: this.usuario().idusuario }
        });
      }
    },
    usuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    editItem(item) {
      let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
      let env = global[global.env];
      this.$aes.setKey(env.path.secret);
      let cifra = this.$aes.encrypt(item.idindicador.toString());
      let temporal =
        Math.random()
          .toString(36)
          .substring(2, 6) +
        cifra +
        Math.random()
          .toString(36)
          .substring(2, 6);
      let encrypted = this.$aes.encrypt(temporal);
      encrypted = encrypted.replace(/\//g, "AbcYq");
      encrypted = encrypted.replace(/\+/g, "qYcbA");
      this.$router.push("/detallepublicoindicador/" + encrypted);

    },
    desagregacionItem(item) {      
      this.$router.push("/detallepublicoindicadordesagregado/" + item.idindicador + "/1");
    },
    filterItems(filters) {
      return this.datos.filter(function (val) {
        for (var i = 0; i < filters.length; i++) {
          if (
            val["tipoclasificador"].indexOf(
              filters[i].toString()
            ) >= 0
          ) return true;

        }
        return false;
      });
    },
    limpiarnombre() {
      this.nombre = "";
      this.filtrar();
    },
    limpiarcodigo() {
      this.codigo = "";
      this.filtrar();
    },
    filtrar() {
      //if (newValue && newValue !== oldValue) {
      let codigo = this.codigo;
      let nombre = this.nombre;
      if (this.codigo === null) codigo = "";
      if (this.nombre === null) nombre = "";
      let filtro = {
        // clasificador: this.tiposclasificador,
        codigo: codigo,
        nombre: nombre,
        sector: (this.sector !== undefined && this.sector !== null) ? this.sector.idsector : 0,
        entidad: (this.entidad !== undefined && this.entidad !== null) ? this.entidad.identidad : 0,
        punto: (this.punto !== undefined && this.punto !== null) ? this.punto.idpunto : 0,
        pilar: (this.pilar !== undefined && this.pilar !== null) ? this.pilar.idpilar : 0,
        estrategia:
          (this.estrategia !== undefined && this.estrategia !== null) ? this.estrategia.idestrategia : 0,
        linea: (this.linea !== undefined && this.linea !== null) ? this.linea.idlinea : 0,
        producto: (this.producto !== undefined && this.producto !== null) ? this.producto.idproducto : 0,
        clasificacion:
          (this.clasificacion !== undefined && this.clasificacion !== null) ? this.clasificacion.idclasificacion : 0
      };
      localStorage.setItem("filtroindicadorP", JSON.stringify(filtro));
      if (this.gindicadores !== undefined) {
        this.datos = this.gindicadores;
        if (this.datos !== null) {
          if (this.tiposclasificador.length > 0) {
            let filtros = [];
            this.tiposclasificador.forEach(element => {
              filtros.push([element.idtipoclasificador]);
            });
            this.datos = this.filterItems(filtros);
          }
          this.datos = this.datos.filter(
            p =>
              p.codigo.toUpperCase().indexOf(codigo.toUpperCase()) !== -1 &&
              p.nombre.toUpperCase().indexOf(nombre.toUpperCase()) !== -1
          );
          if (this.punto !== undefined && this.punto !== null) {
            this.datos = this.datos.filter(
              p => p.idpunto === this.punto.idpunto
            );
          }
          if (this.pilar !== undefined && this.pilar !== null) {
            this.datos = this.datos.filter(
              p => p.idpilar === this.pilar.idpilar
            );
          }
          if (this.estrategia !== undefined && this.estrategia !== null) {
            this.datos = this.datos.filter(
              p => p.idestrategia === this.estrategia.idestrategia
            );
          }
          if (this.linea !== undefined && this.linea !== null) {
            this.datos = this.datos.filter(
              p => p.idlinea === this.linea.idlinea
            );
          }
          if (this.producto !== undefined && this.producto !== null) {
            this.datos = this.datos.filter(
              p => p.idproducto === this.producto.idproducto
            );
          }
          if (this.clasificacion !== undefined && this.clasificacion !== null) {
            this.datos = this.datos.filter(
              p => p.idclasificacion === this.clasificacion.idclasificacion
            );
          }
          if (this.sector !== undefined && this.sector !== null) {
            this.datos = this.datos.filter(p => p.entidades !== null);
            this.datos = this.datos.filter(
              p => p.entidades.idsector === this.sector.idsector
            );
          }
          if (this.entidad !== undefined && this.entidad !== null) {
            this.datos = this.datos.filter(
              p => p.entidades.identidad === this.entidad.identidad
            );
          }
        }
      }
      //}
    },
    cargarsectores() {
      this.get_sectores();
    },
    cargarentidades() {
      this.Getentidad();
    },
    cargaropciones() {
      this.get_porusuario();
    },
    validarpilares() {
      if (this.filtro !== undefined && this.filtro !== null)
        if (this.filtro.pilar !== 0)
          this.pilar = this.gpilares.filter(
            p => p.idpilar === this.filtro.pilar
          )[0];
      if (this.punto !== undefined && this.punto !== null) {
        this.pilares = this.gpilares.filter(
          p => p.idpunto === this.punto.idpunto
        );
        if (this.pilar !== undefined && this.pilar !== null) {
          let temp = this.pilares.filter(
            p => p.idpilar === this.pilar.idpilar
          )[0];
          if (temp === undefined) {
            this.pilar = undefined;
          }
        }
      } else {
        this.pilares = [];
        this.pilar = undefined;
      }
      this.filtrar();
    },
    validarestrategias() {
      if (this.filtro !== undefined && this.filtro !== null)
        if (this.filtro.estrategia !== 0)
          this.estrategia = this.gestrategias.filter(
            p => p.idestrategia === this.filtro.estrategia
          )[0];
      if (this.pilar !== undefined && this.pilar !== null) {
        this.estrategias = this.gestrategias.filter(
          p => p.idpilar === this.pilar.idpilar
        );
        if (this.estrategia !== undefined && this.estrategia !== null) {
          let temp = this.estrategias.filter(
            p => p.idestrategia === this.estrategia.idestrategia
          )[0];
          if (temp === undefined) {
            this.estrategia = undefined;
          }
        }
      } else {
        this.estrategias = [];
        this.estrategia = undefined;
      }
      this.filtrar();
    },
    validarlineas() {
      if (this.filtro !== undefined && this.filtro !== null)
        if (this.filtro.linea !== 0)
          this.linea = this.glineas.filter(
            p => p.idlinea === this.filtro.linea
          )[0];
      if (this.estrategia !== undefined && this.estrategia !== null) {
        this.lineas = this.glineas.filter(
          p => p.idestrategia === this.estrategia.idestrategia
        );
        if (this.linea !== undefined && this.linea !== null) {
          let temp = this.lineas.filter(
            p => p.idlinea === this.linea.idlinea
          )[0];
          if (temp === undefined) {
            this.linea = undefined;
          }
        }
      } else {
        this.lineas = [];
        this.linea = undefined;
      }
      this.filtrar();
    },
    validarentidades() {
      let opciones = this.gopciones.filter(
        p => p.codigo === "O004-1-1" || p.codigo === "O004-1-4"
      )[0];
      if (opciones === undefined) {
        this.entidad = this.gentidades[0];
      }
      if (this.filtro !== undefined && this.filtro !== null) {
        if (this.filtro.entidad !== 0) {
          this.entidad = this.gentidades.filter(
            p => p.identidad === this.filtro.entidad
          )[0];
        } else {
          this.entidad = undefined;
        }
      }
      this.filtrar();
    },
    validarsectores() {

      if (this.filtro !== undefined && this.filtro !== null)
        if (this.filtro.sector !== 0)
          this.sector = this.gsectores.filter(
            p => p.idsector === this.filtro.sector
          )[0];
      this.filtrar();
    },
    validarproductos() {
      if (this.filtro !== undefined && this.filtro !== null)
        if (this.filtro.producto !== 0)
          this.producto = this.gproductos.filter(
            p => p.idproducto === this.filtro.producto
          )[0];
      if (this.linea !== undefined && this.linea !== null) {
        this.productos = this.gproductos.filter(
          p => p.idlinea === this.linea.idlinea
        );
        if (this.producto !== undefined && this.producto !== null) {
          let temp = this.productos.filter(
            p => p.idproducto === this.producto.idproducto
          )[0];
          if (temp === undefined) {
            this.producto = undefined;
          }
        }
      } else {
        this.productos = [];
        this.producto = undefined;
      }
      this.filtrar();
    },
    avanzar(lista) {
      let avanza = false;
      if (lista !== undefined) {
        avanza = lista.length > 0;
      }
      return avanza;
    },
    verificarusuario() {
      if (this.usuario().idusuario > 0) {
        this.showdownload = true;
      }
    }
  },
  watch: {
    gindicadores: function () {
      this.filtrar();
    },
    punto: function () {
      if (this.gpilares !== undefined) {
        this.validarpilares();
      } else {
        store.watch(
          () => store.getters["gpilares"],
          () => {
            this.validarpilares();
          }
        );
      }
    },
    pilar: function () {
      if (this.avanzar(this.gestrategias)) {
        this.validarestrategias();
      } else {
        store.watch(
          () => store.getters["gestrategias"],
          () => {
            this.validarestrategias();
          }
        );
      }
    },
    estrategia: function () {
      if (this.avanzar(this.glineas)) {
        this.validarlineas();
      } else {
        store.watch(
          () => store.getters["glineas"],
          () => {
            this.validarlineas();
          }
        );
      }
    },
    linea: function () {
      if (this.avanzar(this.gproductos)) {
        this.validarproductos();
      } else {
        store.watch(
          () => store.getters["gproductos"],
          () => {
            this.validarproductos();
          }
        );
      }
    },
    sector: function () {
      if (this.sector !== undefined && this.sector !== null) {
        this.get_entidadesbysector({
          params: { idsector: this.sector.idsector }
        });
      } else {
        this.cargarentidades();
      }
      this.entidades = [];
      this.entidad = undefined;
      this.filtrar();
    },
    gopciones: function () {
      this.cargarsectores();
      this.cargarpuntos();
    },
    gpuntos: function () {
      if (this.filtro !== undefined)
        if (this.filtro.punto !== 0)
          this.punto = this.gpuntos.filter(
            p => p.idpunto === this.filtro.punto
          )[0];
    },
    gclasificaciones: function () {
      if (this.filtro !== undefined)
        if (this.filtro.clasificacion !== 0)
          this.clasificacion = this.gclasificaciones.filter(
            p => p.idclasificacion === this.filtro.clasificacion
          )[0];
    },
    gsectores: function () {
      this.sectorbloqueado = true;
      let opciones = this.gopciones.filter(
        p => p.codigo === "O004-1-1" || p.codigo === "O004-1-4"
      )[0];
      if (opciones !== undefined) {
        this.sectorbloqueado = false;
      }
      this.validarsectores();
    },
    gentidades: function () {
      this.entidadbloqueada = true;
      let opciones = this.gopciones.filter(
        p =>
          p.codigo === "O004-1-1" ||
          p.codigo === "O004-1-4" ||
          p.codigo === "O004-1-5"
      )[0];
      if (opciones !== undefined) {
        this.entidadbloqueada = false;
      }
      this.entidades = this.gentidades;
      this.validarentidades();
    },
    ginformation() {
      this.MesaggeInfo = this.ginformation;
      this.snack = true;
    }
  }
};
</script>

<style scoped></style>